import { styled } from 'styled-components';

export const StyledSelect = styled.select`
  width: 100%;
  padding: 10px 40px 10px 14px;
  border: 1.5px solid #E4E7EF;
  border-radius: 10px;
  font-size: 14px;
  color: #1A1D2B;
  background: white;
  background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%238890A5' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3e%3cpolyline points='6 9 12 15 18 9'%3e%3c/polyline%3e%3c/svg%3e");
  background-repeat: no-repeat;
  background-position: right 12px center;
  background-size: 20px;
  appearance: none;
  cursor: pointer;
  transition: all 0.15s ease;
  font-family: -apple-system, BlinkMacSystemFont, 'SF Pro Text', 'Segoe UI', 'Roboto', 'Helvetica Neue', sans-serif;

  &:hover {
    border-color: #CDD1DC;
  }

  &:focus {
    outline: none;
    border-color: #008AFF;
    box-shadow: 0 0 0 3px rgba(0, 138, 255, 0.1);
  }

  &:disabled {
    background-color: #F4F5F9;
    cursor: not-allowed;
    opacity: 0.6;
  }

  option {
    padding: 10px;
    background: white;
    color: #1A1D2B;
  }

  @media (max-width: 768px) {
    font-size: 16px;
    padding: 12px 40px 12px 14px;
  }
`;
